import { render, staticRenderFns } from "./CartRecapulation.vue?vue&type=template&id=97a1fb46"
import script from "./CartRecapulation.vue?vue&type=script&lang=js"
export * from "./CartRecapulation.vue?vue&type=script&lang=js"
import style0 from "./CartRecapulation.vue?vue&type=style&index=0&id=97a1fb46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports